const ONE_BITCOIN = 100000000;
const default_goal = {
  interval: 'WEEKLY',
  target: 100000000,
  stack: 0,
  date: '2028 halving',
  currency: 'USD'
}
// state
const state = () => {
  let goal;
  let start_date = localStorage.getItem('start_date');

  const saved_goal = localStorage.getItem('saved_goal');

  if (saved_goal) {
    goal = JSON.parse(saved_goal);
  }

  return {
    currencies: {},
    intervals: [
      { value: 'DAILY', text: 'Day', singular: 'day', plural: 'days' },
      { value: 'WEEKLY', text: 'Week', singular: 'week', plural: 'weeks' },
      { value: 'MONTHLY', text: 'Month', singular: 'month', plural: 'months' },
      { value: 'QUARTERLY', text: 'Quarter', singular: 'quarter', plural: 'quarters' },
    ],
    goal: {
      ...default_goal,
      ...goal
    },
    has_saved_goal: saved_goal === undefined ? false : true,
    start_date,
  };
}

const getters = {
  get_goal: (state) => state.goal,
  get_exchange_rates: (state) => state.exchange_rates,
  get_currency_price: (state) => state.currency_price,
  get_intervals: (state) => state.intervals,
  get_exchange_rate: (state) => state.exchange_rate,
  get_currency_price: (state) => state.currency_price,
  get_has_saved_goal: (state) => state.has_saved_goal,
  get_start_date: (state) => state.start_date,
  get_currencies: (state) => state.currencies,
  get_show_welcome: (state) => state.show_welcome,
}

const mutations = {
  reset: (state) => {
    state.goal = default_goal;
    localStorage.removeItem('saved_goal');
    localStorage.removeItem('start_date');
  },
  set_goal: (state, payload) => {
    state.goal = payload
    localStorage.setItem('saved_goal', JSON.stringify(state.goal));
  },
  set_interval: (state, payload) => {
    state.goal = { ...state.goal, interval: payload }
    localStorage.setItem('saved_goal', JSON.stringify(state.goal));
  },
  set_target: (state, payload) => {
    state.goal = { ...state.goal, target: payload }
    localStorage.setItem('saved_goal', JSON.stringify(state.goal));
  },
  set_stack: (state, payload) => {
    state.goal = { ...state.goal, stack: payload }
    localStorage.setItem('saved_goal', JSON.stringify(state.goal));
  },
  set_date: (state, payload) => {
    state.goal = { ...state.goal, date: payload }
    localStorage.setItem('saved_goal', JSON.stringify(state.goal));
  },
  set_start_date: (state, payload) => {
    state.start_date = payload;
    localStorage.setItem('start_date', payload);
  },
  set_get_started: (state, payload) => {
    state.start_date = payload;
    state.goal = default_goal;
    localStorage.setItem('saved_goal', JSON.stringify(state.goal));
    localStorage.setItem('start_date', state.start_date);
  },
  set_currency: (state, payload) => {
    state.goal = { ...state.goal, currency: payload };
    localStorage.setItem('saved_goal', JSON.stringify(state.goal));
  },
  set_exchange_rates: (state, payload) => {
    state.exchange_rates = payload;
  },
  set_currencies: (state, payload) => {
    state.currencies = payload;
  },

}

const actions = {
  async fetch_exchange_rates({ commit }) {
    const { data: { rates: exchange_rates } } = await this.$axios.$get('https://api.coinbase.com/v2/exchange-rates?currency=BTC')

    commit('set_exchange_rates', exchange_rates);
  },

  async fetch_currencies({ commit }) {
    const { data } = await this.$axios.$get('https://api.coinbase.com/v2/currencies')

    commit('set_currencies', data);
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
};